// Duración del SLA siempre con días: "0 días 23 h 05 m 12 s"
export const formatSlaDuration = totalSeconds => {
  const seconds = Math.max(0, Math.floor(Math.abs(Number(totalSeconds) || 0)))
  const days = Math.floor(seconds / 86400)
  const hours = Math.floor((seconds % 86400) / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const pad = n => String(n).padStart(2, '0')

  return `${days} ${days === 1 ? 'día' : 'días'} ${pad(hours)} h ${pad(minutes)} m ${pad(seconds % 60)} s`
}
